import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface ActiveCall {
  taskId: string;
  company: string;
  status: 'calling' | 'in_progress' | 'on_hold';
  startedAt: number; // Date.now() timestamp
}

interface CompletedCall {
  taskId: string;
  company: string;
  callId?: string;
  sessionId?: string;
  duration?: number;
  taskRefCode?: string;
  outcome?: 'success' | 'failed';
  dataCollected?: Record<string, string>;
  failureReason?: string;
  nextSteps?: string[];
  targetPhone?: string;
}

interface CallState {
  activeCall: ActiveCall | null;
  completedCall: CompletedCall | null;
  setActiveCall: (call: ActiveCall | null) => void;
  clearActiveCall: () => void;
  setCompletedCall: (call: CompletedCall | null) => void;
  clearCompletedCall: () => void;
}

export const useCallStore = create<CallState>()(
  persist(
    (set) => ({
      activeCall: null,
      completedCall: null,
      setActiveCall: (call) => set({ activeCall: call }),
      clearActiveCall: () => set({ activeCall: null }),
      setCompletedCall: (call) => set({ completedCall: call }),
      clearCompletedCall: () => set({ completedCall: null }),
    }),
    {
      name: 'reeva-active-call',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
